import { ApplicationListItem } from "../../dtos/ApplicantListItem"
import {
    GetAllApplicantsForVacancyId,
    createExpertInterview,
    createScreeningCall,
    updateInterviewNotes as updateInterviewNotesApi,
    createVideoInterview as createVideoInterviewApi,
    getQuestions as getQuestionsApi,
} from "../../applicants-service"
import { useSelector } from "react-redux"
import { selectCurrentOrganization } from "@/modules/organizations/store/organizationSlice"
import { CreateExpertInterviewCommand } from "../../dtos/CreateExpertInterviewCommand"
import { CreateVideoInterviewCommand } from "../../dtos/CreateVideoInterviewCommand"

export function useApplicants() {
    const currentOrganization = useSelector(selectCurrentOrganization)

    const getApplicants = (vacancyId: string): Promise<ApplicationListItem[]> => {
        const applicants = GetAllApplicantsForVacancyId(
            currentOrganization?.id ?? "",
            vacancyId,
        )
        return applicants
    }

    const createInterview = async (applicationId: string) => {
        if (!currentOrganization?.id) return
        return await createScreeningCall(currentOrganization.id, applicationId)
    }

    const scheduleExpertInterview = async (
        command: CreateExpertInterviewCommand,
    ) => {
        if (!currentOrganization?.id) return
        return await createExpertInterview(currentOrganization.id, command)
    }

    const updateInterviewNotes = async (interviewId: string, notes: string) => {
        if (!currentOrganization?.id) return
        return await updateInterviewNotesApi(
            currentOrganization.id,
            interviewId,
            notes,
        )
    }

    const createVideoInterview = async (
        command: CreateVideoInterviewCommand,
    ) => {
        if (!currentOrganization?.id) return
        return await createVideoInterviewApi(currentOrganization.id, command)
    }

    const getQuestions = async (searchTerm?: string) => {
        if (!currentOrganization?.id) return []
        return await getQuestionsApi(currentOrganization.id, searchTerm)
    }

    return {
        getApplicants,
        createInterview,
        scheduleExpertInterview,
        createVideoInterview,
        updateInterviewNotes,
        getQuestions,
    }
}
